export interface IFavourite {
    SystemId: number;
    PreviewImage: string;
    Address: string;
    Price: string;
    Beds: number;
    Baths: number;
    DOM: number;
    Status: string;
    StatusCode: string;
}

export class Favourite implements IFavourite {
    public SystemId: number;
    public PreviewImage: string;
    public Address: string;
    public Price: string;
    public Beds: number;
    public Baths: number;
    public DOM: number;
    public Status: string;
    public StatusCode: string;
    constructor(
        favProps: any,
    ) {
        this.SystemId = favProps.SystemId;
        this.PreviewImage = favProps.PreviewImage;
        this.Address = favProps.Address;
        this.Price = favProps.Price;
        this.Beds = favProps.Beds;
        this.Baths = favProps.Baths;
        this.DOM = favProps.DOM;
        this.Status = favProps.Status;
        this.StatusCode = favProps.StatusCode;
    }
}

